import { post } from "./api";

export const subscribeToMailchimp = async (email: string) => {
  await post("/api/v2/mailchimp/newsletter", { email });
};